/* Solid Viibe enhancement motion. Safe to re-run when Shopify reloads a section. */
(function () {
  'use strict';
  var reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fineQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  var countObserver = null;

  function scrollProgress() {
    var bar = document.querySelector('.sv-progress i');
    var nativeTimeline = window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()');
    if (!bar || nativeTimeline || bar.dataset.motionReady) return;
    bar.dataset.motionReady = 'true';
    var ticking = false;
    function draw() {
      ticking = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var progress = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
      bar.style.setProperty('--p', progress.toFixed(4));
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(draw); }
    }, { passive: true });
    window.addEventListener('resize', draw, { passive: true });
    draw();
  }

  function magnetic(scope) {
    if (!fineQuery.matches) return;
    scope.querySelectorAll('[data-mag]').forEach(function (el) {
      if (el.dataset.magneticReady) return;
      el.dataset.magneticReady = 'true';
      var frame = null;
      el.addEventListener('pointermove', function (event) {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = null;
          var rect = el.getBoundingClientRect();
          var dx = (event.clientX - (rect.left + rect.width / 2)) / Math.max(rect.width / 2, 1);
          var dy = (event.clientY - (rect.top + rect.height / 2)) / Math.max(rect.height / 2, 1);
          el.style.setProperty('--mx', (dx * 7).toFixed(2) + 'px');
          el.style.setProperty('--my', (dy * 5).toFixed(2) + 'px');
        });
      });
      el.addEventListener('pointerleave', function () {
        if (frame) { cancelAnimationFrame(frame); frame = null; }
        el.style.setProperty('--mx', '0px');
        el.style.setProperty('--my', '0px');
      });
    });
  }

  function countFigures(scope) {
    if (!('IntersectionObserver' in window)) return;
    if (!countObserver) {
      countObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          countObserver.unobserve(entry.target);
          runCount(entry.target);
        });
      }, { threshold: 0.4 });
    }
    scope.querySelectorAll('.a-figure b').forEach(function (el) {
      if (el.dataset.countReady) return;
      el.dataset.countReady = 'true';
      countObserver.observe(el);
    });
  }

  function runCount(el) {
    var raw = el.textContent.trim();
    var match = raw.match(/^([\d.]+)(.*)$/);
    if (!match) return;
    var target = parseFloat(match[1]);
    var suffix = match[2] || '';
    var decimals = (match[1].split('.')[1] || '').length;
    if (!isFinite(target)) return;
    var start = null;
    var width = el.getBoundingClientRect().width;
    if (width) el.style.minWidth = width + 'px';
    function step(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min(1, (timestamp - start) / 900);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = (target * eased).toFixed(decimals) + suffix;
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = match[1] + suffix;
    }
    el.textContent = (0).toFixed(decimals) + suffix;
    requestAnimationFrame(step);
  }

  function init(scope) {
    if (reducedQuery.matches) return;
    scrollProgress();
    magnetic(scope || document);
    countFigures(scope || document);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  if (reducedQuery.addEventListener) {
    reducedQuery.addEventListener('change', function () {
      if (!reducedQuery.matches) init(document);
    });
  }
})();
